import togglePageScroll from '@propertypal/web-app/src/utils/togglePageScroll';
import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import Container from './ModalWrapper.style';

interface Props {
  scrollSelector?: string | string[];
  ariaLabel?: string;
  show: boolean;
  onClose: () => void;
  children: ReactNode;
}

interface State {
  root: HTMLElement | null;
}

const toggleScroll = (value: boolean, selectors: string | string[]) => {
  if (Array.isArray(selectors)) {
    togglePageScroll('#modalWrapper', value, selectors);
  } else {
    togglePageScroll(selectors, value);
  }
};

class ModalWrapper extends React.Component<Props, State> {
  state: State = {
    root: null,
  };

  componentDidMount() {
    this.setState({
      root: document.getElementById('modal-root'),
    });

    window.addEventListener('keydown', this.handleKeyPress);
  }

  shouldComponentUpdate(nextProps: Readonly<Props>) {
    if (this.props.show && !nextProps.show && nextProps.scrollSelector) {
      toggleScroll(true, nextProps.scrollSelector);
    }

    return true;
  }

  componentDidUpdate() {
    if (this.props.show && this.props.scrollSelector) {
      toggleScroll(false, this.props.scrollSelector);
    }
  }

  componentWillUnmount() {
    if (this.props.scrollSelector) {
      toggleScroll(true, this.props.scrollSelector);
    }

    window.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Escape' && this.props.show) {
      this.props.onClose();
    }
  };

  render() {
    const Content = (
      <Container id="modalWrapper" role="dialog" aria-label={this.props.ariaLabel} data-testid="modal-container">
        {this.props.children}
      </Container>
    );

    if (this.props.show && this.state.root) {
      return ReactDOM.createPortal(Content, this.state.root);
    }

    return null;
  }
}

export default ModalWrapper;
